import * as React from 'react';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { Card, DateTime, Icon, Tag, Tooltip, BookingItem, Loader } from '../';
import Box from '../Box/Box';

interface Vehicle {
  registration: string;
}

interface VehicleType {
  name: string;
}

interface Booking {
  id: number;
  company_id: number;
  invoiceId: number;
  order_number?: string;
  contact_name?: string;
  contact_phone_number?: string;
  vehicle: Vehicle;
  vehicle_type: VehicleType;
  payment_status: number;
  total_cost: number;
  start: string;
  end: string;
  created_at: string;
  updated_at: string;
}

type PaymentType = 'CASH' | 'CARD' | 'BACS' | 'CHEQUE' | 'ACCOUNT' | 'PRE-AUTH';
type PaymentOrigin = 'SYSTEM' | 'SAGEPAY';

interface Payment {
  id: number;
  subtotal: number;
  vat: number;
  total: number;
  is_archived: boolean;
  booking: Booking;
  type?: PaymentType;
  origin?: PaymentOrigin;
  description?: string;
}

interface Props {
  payment: any;
}

/**
 * Display all the details for the payment provided
 */
const PaymentItem = ({ payment }: Props) => {
  if (!payment) {
    return <Loader fullwidth />;
  }

  const booking: Booking = payment.booking;

  let typeColour = 'primary';
  if (payment) {
    switch (payment.type) {
      case 'ACCOUNT':
        typeColour = 'success';
        break;
      case 'CREDIT-NOTE':
        typeColour = 'danger';
        break;
      case 'PRE-AUTH':
        typeColour = 'warning';
        break;
    }
    if (payment.origin === 'SAGEPAY') {
      typeColour = 'info';
    }
  }

  return (
    <>
      <Box>
        <table className="field">
          <tbody>
            <tr>
              <th>Subtotal</th>
              <td className="has-text-right">
                {payment && `£${Number(payment.subtotal).toFixed(2)}`}
              </td>
            </tr>
            <tr>
              <th>VAT</th>
              <td className="has-text-right">
                {payment && `£${Number(payment.vat).toFixed(2)}`}
              </td>
            </tr>
            <tr>
              <th>Total</th>
              <td className="has-text-right">
                <strong className="is-size-4">
                  {payment && `£${Number(payment.total).toFixed(2)}`}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
      <label className="label">Associated Booking</label>
      <BookingItem
        booking={booking}
        link={`/bookings/${booking.id}`}
        hideControls
      />
      <br />
      <label className="label">Additional Information</label>
      <Box>
        <table className="field">
          <tbody>
            <tr>
              <th>Type</th>
              <td className="has-text-right">
                <Tag type={typeColour}>
                  {payment.type}
                  {payment.origin === 'SAGEPAY' && ' (ONLINE)'}
                </Tag>
              </td>
            </tr>
            <tr>
              <th>Origin</th>
              <td className="has-text-right">
                <Tag type="default">{payment.origin}</Tag>
              </td>
            </tr>
            <tr>
              <th>Date</th>
              <td className="has-text-right">
                <DateTime date={payment.created_at} />
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </>
  );
};

export default PaymentItem;
